import styled from "styled-components/macro";
import React, { useState } from "react";
import { Button } from "antd";
import { useAcceptChat } from "API/queries/chatApiQueries";
import { ArchiveChatRequestModal } from "../../Modals";
import { useNotifier } from "../../../../context/ContextNotifier";
import { InfoBox } from "../../../InfoBox/InfoBox";
import { useIsMobile } from "../../../../utils/hooks/useWindowSize";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
  @media ${(props) => props.theme.media.phone} {
    margin: 0;
    padding: 0 8px;
  }
  /* box-sizing: border-box;

  min-width: calc(100% - 32px);  // assuming the parent container is the full width of the screen */
`;

const Inner = styled.div`
  padding: 16px;
  background: #f4f4f4;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
const TextTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 16px;

  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

const Text = styled.div`
  margin-bottom: 16px;
`;
const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  & > button {
    flex-grow: 1;
  }
`;

export const HostAcceptRequestMessage: React.FC<{
  chatId: string;
  t: Function;
}> = React.memo(({ chatId, t }) => {
  const acceptChat = useAcceptChat();
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const notifier = useNotifier();

  const isMobile = useIsMobile();
  return (
    <Root>
      <Inner>
        <TextTitle>
          {t("systemMessages.hostAcceptRequestMessage.title")}
        </TextTitle>
        <Text>{t("systemMessages.hostAcceptRequestMessage.textInterest")}</Text>
        <InfoBox>
          {t("systemMessages.hostAcceptRequestMessage.textInterestInfoBox")}
        </InfoBox>
        <ButtonsContainer>
          <Button
            size="large"
            type="default"
            onClick={() => {
              setShowArchiveModal(true);
            }}
          >
            {isMobile
              ? t("systemMessages.hostAcceptRequestMessage.buttonDecline")
              : t(
                  "systemMessages.hostAcceptRequestMessage.buttonDeclineAndArchive"
                )}
          </Button>
          <Button
            size="large"
            type="primary"
            loading={acceptChat.isLoading}
            onClick={() => {
              acceptChat.mutate(
                { chatId },
                {
                  onSuccess: () => {
                    notifier.success({
                      message: t(
                        "systemMessages.candidateAccepted.popUpSuccess"
                      )
                    });
                  }
                }
              );
            }}
          >
            {isMobile
              ? t("systemMessages.hostAcceptRequestMessage.buttonAccept")
              : t("systemMessages.hostAcceptRequestMessage.buttonAcceptMobile")}
          </Button>
        </ButtonsContainer>
      </Inner>
      {showArchiveModal ? (
        <ArchiveChatRequestModal
          chatId={chatId}
          isShow={true}
          onArchived={() => setShowArchiveModal(false)}
          onClose={() => setShowArchiveModal(false)}
        />
      ) : null}
    </Root>
  );
});
